import {Program} from '../../../programs/shared/model/program';

export interface ProgramsState {
  programs: Program[];
}

export const initialProgramsState: ProgramsState = {
  programs: [],
};
